import { render, staticRenderFns } from "./role-edit-add.vue?vue&type=template&id=e4d5538c&scoped=true&"
import script from "./role-edit-add.vue?vue&type=script&lang=js&"
export * from "./role-edit-add.vue?vue&type=script&lang=js&"
import style0 from "./role-edit-add.vue?vue&type=style&index=0&id=e4d5538c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d5538c",
  null
  
)

export default component.exports